export default __webpack_public_path__ + "static/media/EAST1890.34I-40948_-24296_0.202d8b1b.jpg";